import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  CircularProgress,
} from "@mui/material";

/**
 * Reusable confirm dialog — use for logout, admin switch, delete, etc.
 */
const ConfirmDialog = ({
  open,
  title = "Confirm",
  message = "Are you sure you want to continue?",
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  confirmColor = "primary",
  loading = false,
  onConfirm,
  onCancel,
}) => {
  return (
    // <Dialog
    //   open={open}
    //   onClose={loading ? undefined : onCancel}
    //   maxWidth="xs"
    //   fullWidth
    //   aria-labelledby="confirm-dialog-title"
    //   PaperProps={{
    //     sx: {
    //       borderRadius: "var(--radius-lg)",
    //       border: "1px solid",
    //       borderColor: "divider",
    //       boxShadow: "var(--shadow-md)",
    //     },
    //   }}
    // >
<Dialog
  open={open}
  onClose={loading ? undefined : onCancel}
  maxWidth="xs"
  fullWidth
  aria-labelledby="confirm-dialog-title"
  container={() => document.body}
  sx={{
    zIndex: 999999,
  }}
  PaperProps={{
    sx: {
      borderRadius: "var(--radius-lg)",
      border: "1px solid",
      borderColor: "divider",
      boxShadow: "var(--shadow-md)",
    },
  }}
>
      <DialogTitle
        id="confirm-dialog-title"
        sx={{ fontWeight: 650, fontSize: 16, pb: 1 }}
      >
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ fontSize: 14, color: "text.secondary" }}>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
        <Button
          onClick={onCancel}
          disabled={loading}
          color="inherit"
          variant="outlined"
          sx={{ borderRadius: "var(--radius-md)", textTransform: "none" }}
        >
          {cancelLabel}
        </Button>
        <Button
          onClick={onConfirm}
          color={confirmColor}
          variant="contained"
          disabled={loading}
          disableElevation
          startIcon={
            loading ? <CircularProgress size={16} color="inherit" /> : null
          }
          sx={{ borderRadius: "var(--radius-md)", textTransform: "none" }}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
